<template>
  <div id="management" v-if="fileOnFlow.detalle.ejecucion">
    <div class="row">
      <div class="col-1 position-relative text-center">
        <div v-if="fileOnFlowAttachments.length" class="container-attachment">
          <div
            class="box-attachments"
            v-for="attachment in fileOnFlowAttachments"
            :key="attachment.url"
            @click="selectFile(attachment)"
          >
            <b-button
              v-if="!attachment.esInicial"
              variant="outline-primary"
              class="btn-icon mt-2 text-center shadow"
            >
              <feather-icon icon="FileIcon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-warning"
              v-if="attachment.esInicial"
              class="btn-icon mt-2 text-center shadow"
            >
              <feather-icon icon="FileTextIcon" />
            </b-button>
          </div>
          <div class="position-fixed manage-comments text-left m-auto">
            <div>
              <h6 style="font-size: 12px;" class="my-2">
                comentarios
              </h6>
              <b-button
                id="toggle-btn"
                v-b-modal="'modal-comments'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon rounded-circle shadow-lg"
              >
                <feather-icon icon="MessageCircleIcon" />
              </b-button>
              <Comments
                v-if="fileOnFlow.detalle && fileOnFlow.detalle.ejecucion"
                :comments="fileOnFlow.detalle.ejecucion.comentarios"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-7">
        <a :href="filePdf.url" v-if="selectedFile" target="_blank">
          <h5 class="text-primary underline d-inline-block mr-2">
            * Visualizando documento seleccionado {{filePdf.nombreCompleto}} *
          </h5>
          <feather-icon icon="ExternalLinkIcon" />
        </a>
        <div v-if="!isImage" class="d-flex">
          <div v-if="selectedFile" ref="pdfViewport" class="shadow container-pdf">
            <pdf
              class="mt-2"
              v-for="i in numPages"
              :key="i"
              :page="i"
              :src="selectedFile"
            />
          </div>
        </div>
      </div>
      <div class="col-4">
        <b-card class="shadow border-0 pt-0">
          <div class="bg-white pb-2">
            <h5 class="card-title mb-0" v-if="fileOnFlow.detalle && fileOnFlow.detalle.ejecucion">
              Expediente # {{fileOnFlow.detalle.ejecucion.numero}} en el
              {{fileOnFlow.detalle.ejecucion.nombre}}
            </h5>
          </div>
          <b-card-body class="p-0">
            <div class="mt-2 shadow">
              <Steps
                v-if="fileOnFlow.detalle && fileOnFlow.detalle.pasos"
                :steps="fileOnFlow.detalle.pasos"
                :ejecucion="fileOnFlow.detalle.ejecucion"
              />
            </div>
            <div class="mt-5 container-actions" v-if="fileOnFlow.detalle">
              <ManageDocument
                title="Reenviar"
                action="resend"
                color="outline-info"
                :step-id="step"
              />
              <ManageDocument
                title="Devolver"
                action="return"
                color="outline-warning"
                :step-id="step"
              />
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import pdf from 'vue-pdf-signature';
import Ripple from 'vue-ripple-directive';
import { VBTooltip, } from 'bootstrap-vue';

import ManageDocument from '@/febos/chile/approvals/components/trays/managementTray/ManageDocument';
import Steps from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Steps';
import Comments from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Comments';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export default {
  components: {
    pdf,
    ManageDocument,
    Steps,
    Comments
  },
  data() {
    return {
      isImage: false,
      stepTypes: StepTypes,
      selectedFile: '',
      numPages: undefined,
      filePdf: {},
      titleSign: 'Firmar'
    };
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#management > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#management',
        scale: 0.6
      });
    },
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters('Approvals', [
      'loading',
      'fileOnFlow',
      'fileOnFlowAttachments'
    ]),
    step() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      return this.fileOnFlow.detalle && pasos.find((step) => step.id === ejecucion.pasoActualId);
    },
    canReturn() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion = {} } = detalle;
      const { reversible } = ejecucion;
      const actualStep = pasos.find((step) => step.id === ejecucion.pasoActualId);
      if (!actualStep) return false;
      const isTemporal = actualStep.esTemporal;
      return actualStep.numeroPaso.toString() !== '1' && reversible && !isTemporal;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'getApprovalFileDetails',
      'getAttachmentFiles',
    ]),
    ...mapActions('Dnts', [
      'getFileDnt'
    ]),
    ...mapActions('Management', [
      'fetchAllDocuments'
    ]),
    selectFile(file) {
      console.log('AOL', file);
      if (file && (file.url.includes('png')
        || file.url.includes('jpg')
        || file.url.includes('jpeg'))
      ) {
        this.isImage = true;
        this.selectedFile = file;
        this.sign = false;
        return;
      }
      if (file && file.url.includes('pdf')) {
        this.filePdf = file;
        this.isImage = false;
        this.selectedFile = pdf.createLoadingTask(this.filePdf.url);
        this.selectedFile.promise.then((pdfUrl) => {
          this.numPages = pdfUrl.numPages;
        });
      }
    }
  },
  async mounted() {
    const { fileId } = this.$route.params;
    const { flowId } = this.$route.params;
    await this.fetchAllDocuments();
    try {
      await Promise.all([
        this.getApprovalFileDetails({
          aprobacionId: fileId,
          ejecucionId: flowId,
          retornarPdf: 'no'
        }),
        this.getAttachmentFiles({
          aprobacionId: fileId,
          ejecucionId: flowId
        })
      ]);
      await this.getFileDnt({
        febosId: this.fileOnFlow.detalle.documentosBase[0].objetoId,
        destinatarios: 'si',
        retornarDnt: 'si'
      });
      await this.selectFile(this.fileOnFlowAttachments[0]);
    } catch (error) {
      console.error(error);
    }
  }
};
</script>
<style>
.annotationLayer {
  position: absolute !important;
}

.linkAnnotation {
  transform: unset !important;
  transform-origin: unset !important;
  left: unset !important;
  top: unset !important;
  right: 0 !important;
  bottom: 0 !important;
}

.selected {
  background-color: rgba(116, 74, 135, 0.49);
  border: 1px solid rgb(230 191 247);
}

.manage-comments {
  bottom: 60px;
}
.container-attachment {
  max-height: 55vh;
  overflow-y: scroll;
}
.container-actions {
  height: 280px;
  overflow-y: scroll;
}

.container-pdf {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
